import React from 'react';
import { Coins, Cpu, Hash, Bot } from 'lucide-react';
import { fmtCost, fmtInt, fmtTokens } from './format';

const Kpi = ({ icon: Icon, label, value, sub, color = 'text-foreground', testid }) => (
  <div className="bg-card border border-border rounded-sm p-4" data-testid={testid}>
    <div className="flex items-center gap-2 text-muted-foreground">
      <Icon className="w-3.5 h-3.5" strokeWidth={1.5} />
      <span className="text-[10px] uppercase tracking-wider">{label}</span>
    </div>
    <div className={`text-2xl font-heading mt-2 ${color}`}>{value}</div>
    {sub && <div className="text-[10px] font-mono text-muted-foreground mt-0.5">{sub}</div>}
  </div>
);

export const CostKpis = ({ data }) => {
  const t = data.total;
  const cc = data.claude_connect;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="ai-costs-kpis">
      <Kpi icon={Coins} label="KI-Kosten im Zeitraum" value={fmtCost(t.cost)} color="text-amber-400" testid="ai-costs-kpi-total"
        sub={`heute ${fmtCost(data.today_cost)}`} />
      <Kpi icon={Cpu} label="KI-Aufrufe" value={fmtInt(t.calls)} testid="ai-costs-kpi-calls"
        sub={t.errors > 0 ? `${fmtInt(t.errors)} fehlgeschlagen` : 'keine Fehler'} />
      <Kpi icon={Hash} label="Tokens Eingabe / Ausgabe" value={`${fmtTokens(t.prompt_tokens)} / ${fmtTokens(t.completion_tokens)}`} testid="ai-costs-kpi-tokens"
        sub={`${fmtInt(t.prompt_tokens + t.completion_tokens)} gesamt`} />
      <Kpi icon={Bot} label="Claude Connect" value={`${fmtInt(cc.calls)} Anfragen`} color="text-orange-300" testid="ai-costs-kpi-claude"
        sub={`≈ ${fmtTokens(cc.approx_tokens)} Tokens übertragen · keine OLTA-Credits`} />
    </div>
  );
};
